import MenuItemIcon from '../MenuItemIcon/MenuItemIcon'
import type { MenuFamilyItemView, MenuIconProps } from '../types'
import { StyledFlyoutCurrentRow, StyledFlyoutNote, StyledFlyoutRow } from '../styled-components'

interface MenuFlyoutRowProps {
  item: MenuFamilyItemView
  iconProps: MenuIconProps
  onClick: () => void
}

const MenuFlyoutRow = ({ item, iconProps, onClick }: MenuFlyoutRowProps) => {
  if (item.current) {
    return (
      <StyledFlyoutCurrentRow
        id={item.id}
        role='menuitem'
        aria-disabled='true'
        aria-label={item.ariaLabel}
        tabIndex={-1}
      >
        <MenuItemIcon icon={item.icon} iconProps={iconProps} />
        <span>{item.label}</span>
        <StyledFlyoutNote>{item.note}</StyledFlyoutNote>
      </StyledFlyoutCurrentRow>
    )
  }

  return (
    <StyledFlyoutRow
      to={item.to}
      id={item.id}
      role='menuitem'
      aria-label={item.ariaLabel}
      tabIndex={-1}
      onClick={onClick}
    >
      <MenuItemIcon icon={item.icon} iconProps={iconProps} />
      <span>{item.label}</span>
    </StyledFlyoutRow>
  )
}

export default MenuFlyoutRow
